"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListItemStatus = void 0;
var WaitListItemStatus;
(function (WaitListItemStatus) {
    WaitListItemStatus["NEW"] = "NEW";
    WaitListItemStatus["REDEEMED"] = "REDEEMED";
})(WaitListItemStatus || (exports.WaitListItemStatus = WaitListItemStatus = {}));
//# sourceMappingURL=item.js.map